var $DOM = document.getElementsByTagName('html')[0],
    $wW, $hW, wScroll;
/* ---------- CROSSBROWSER BEGIN ---------- */
var userAgent = detect.parse(navigator.userAgent),
    browserFamily = userAgent.browser.family,
    browserVersion = userAgent.browser.major;
if (browserFamily === 'Safari' || browserFamily === 'Mobile Safari'){
    $('html').addClass('on-safari-' + browserVersion);
    if(browserVersion < 14) crossBrowserInputFile();
}
//for IE
if (browserFamily === 'IE' || browserFamily === 'IE Mobile'){
    $('html').addClass('on-ie-' + browserVersion);
    crossBrowserInputFile();
}
/* ---------- CROSSBROWSER END ---------- */

var WIDTH_PERCENTAGE = .8; // '1' would set the width to 100%
var w1 = "innerHeight" in window 
    ? window.innerWidth
    : document.documentElement.offsetWidth;
    w1 *= WIDTH_PERCENTAGE;

/* ---------- SERVICE FUNCTION BEGIN ---------- */
function unwrap(wrapper) {
    var docFrag = document.createDocumentFragment();
    while (wrapper.firstChild) {
        var child = wrapper.removeChild(wrapper.firstChild);
        docFrag.appendChild(child);
    }
    wrapper.parentNode.replaceChild(docFrag, wrapper);
}
function ucFirst(str) {
    if (!str) return str;
    return str[0].toUpperCase() + str.slice(1);
}
function removeChildAll(arr){
    for(var i = 0; i < arr.length; i++){
        removeChild(arr[i]);
    }
}
function removeChild(el) {
    if(el.parentNode != null) el.parentNode.removeChild(el);
}
function setAttributes(attrSet, el) {
    for(var key in attrSet) el.setAttribute(key, attrSet[key]);
}
function removeAttributes(attrRemove, el) {
    attrRemove.forEach(function(item){
        el.removeAttribute(item);
    });
}
function selected(selection, el) {
    var res = false;
    selection.map(function (item){
        if(item == el) res = true;
    });
    return res;
/*    return selection.join().search(el) != -1 ? true : false;*/
}
/* ---------- SERVICE FUNCTION END ---------- */

//for THEME
function initTheme(){
    var themeTrigger = document.querySelectorAll('.theme-switcher__item');
    var themeType = localStorage.getItem('mbTheme');
    for(var i = 0; i < themeTrigger.length; i++){
        if(themeType){
            if(themeTrigger[i].getAttribute('data-id') === 'dark'){
                themeTrigger[i].classList.add('theme-active');
            }else{
                themeTrigger[i].classList.remove('theme-active');
            }
            document.documentElement.setAttribute('data-theme', themeType);
        }else{
            if(themeTrigger[i].getAttribute('data-id') === 'dark'){
                themeTrigger[i].classList.remove('theme-active');
            }else{
                themeTrigger[i].classList.add('theme-active');
            }
        }
    }
}
function choiceTheme(){
    var themeTrigger = document.querySelectorAll('.theme-switcher__item');
    var themeType = localStorage.getItem('mbTheme');
    for(var i = 0; i < themeTrigger.length; i++){
        if(themeType){
            if(themeTrigger[i].getAttribute('data-id') === 'dark'){
                themeTrigger[i].classList.remove('theme-active');
            }else{
                themeTrigger[i].classList.add('theme-active');
            }
            document.documentElement.removeAttribute('data-theme');
            localStorage.removeItem('mbTheme');
            setCookie('theme', 'light');
        }else{
            if(themeTrigger[i].getAttribute('data-id') === 'dark'){
                themeTrigger[i].classList.add('theme-active');
            }else{
                themeTrigger[i].classList.remove('theme-active');
            }
            document.documentElement.setAttribute('data-theme', 'dark');
            localStorage.setItem('mbTheme', 'dark');
            setCookie('theme', 'dark');
        }
    }
}

function scrollbarWidth() {
    var documentWidth = parseInt(document.documentElement.clientWidth),
        windowsWidth = parseInt(window.innerWidth),
        scrollbarWidth = windowsWidth - documentWidth;
    return scrollbarWidth;
}
function showTopNavMenu(){
    closePreview();
    $(".main-wrapper").append('<div class="previewOverlay" onclick="closeTopNavMenu()"></div>');
    if($('#aside')) $('#aside').addClass('popup').removeClass('open');
    if($('#mob-menu-open')) $('#mob-menu-open').addClass('d-none');
    if($('#popup_lady_image')) $('#popup_lady_image').remove();
    if($('.popup .first-row input')) $('.popup .first-row input').focus();
    minHW();
}
function closeTopNavMenu() {
    if($('#aside')) $('#aside').removeClass('popup open fixed');
    if($('#mob-menu-open')) $('#mob-menu-open').removeClass('d-none');
    if(!$('.preview_anketa_block').length){
        if($('.previewOverlay')) $('.previewOverlay').remove();
        if($('.closeTopNav')) $('.closeTopNav').remove();
        minHW();
    }
    if(localStorage.getItem('form')){
        localStorage.removeItem('form');
    }
}
function resizeTopNavMenu(){
    if($wW > 1200){
        if(!localStorage.getItem('form')){
            closeTopNavMenu();
        }
    }else if($wW >= 768){
        if($('#aside').hasClass('popup') || $('#aside').hasClass('open')){
            if($('#aside').hasClass('aside-nav')){
                $('#aside').addClass('open').removeClass('popup');
                if(!$('.preview_anketa_block').length){
                    if($('.previewOverlay')) $('.previewOverlay').remove();
                    if($('.closeTopNav')) $('.closeTopNav').remove();
                    minHW();
                }
            }else{
                showTopNavMenu();
            }
        }
    }else{
        if($('#aside').hasClass('popup') || $('#aside').hasClass('open')) showTopNavMenu();
    }
}
function minHW() {
    var $aside = document.getElementById('aside'),
        wrapper = document.querySelector('.main-wrapper'),
        hNav = $aside.clientHeight + 100,
        h;
    if(hNav < $hW){
        h = $hW;
        $aside.classList.add('fixed');
    }else{
        h = hNav;
        $aside.classList.remove('fixed');
    }
    if($aside.classList.contains('popup')) {
        wrapper.setAttribute('style', 'max-height:' + h + 'px; min-height:' + h + 'px;  padding-right:' + wScroll + 'px; overflow: hidden;');
    }else{
        wrapper.removeAttribute('style');
    }
}
function marginFooter(){
    var footerHeight = $('#footer').innerHeight(),
        leftHeight = $('#top-nav-menu').innerHeight(),
        wrapperHeight = $('.main-wrapper').innerHeight(),
        mainHeight = $('#container-wrap').innerHeight() + $('#header').innerHeight(),
        marginTop =  (footerHeight + (leftHeight - mainHeight)) < $hW ? ($hW - footerHeight) : (leftHeight - mainHeight);
    if(leftHeight > wrapperHeight){
        $('.main-wrapper').css('min-height', leftHeight);
    }else{
        $('.main-wrapper').removeAttr('style');
    }
    leftHeight > mainHeight ? $('#footer').css('margin-top', marginTop) :  $('#footer').css('margin-top', 0);
}
function posPreview(){
    var preview = document.querySelector('.preview_anketa_block'),
        wrapper = document.querySelector('.main-wrapper'),
        hPreview = preview.clientHeight + 100,
        h;
    if(hPreview < $hW){
        h = $hW;
        preview.classList.add('fixed');
    }else{
        h = hPreview;
        preview.classList.remove('fixed');
    }
    wrapper.setAttribute('style', 'max-height:' + h + 'px; min-height:' + h + 'px;  padding-right:' + wScroll + 'px; overflow: hidden;');
}

/* ------------- FORMS BEGIN ------------- */
//for PASSWORD TRIGGER
function initPassword(){
    if (!document.querySelectorAll('.password_icon').length) return;
    var passwordTrigger = document.querySelectorAll('.password_icon');
    var triggerPassword = function (e) {
        var el = e.target;
        var formGroup = el.parentNode;
        var input = formGroup.querySelector('input');
        var type = input.getAttribute('type') == "text" ? "password" : 'text';
        input.setAttribute('type', type);
        formGroup.classList.toggle('password-show');
    };
    for(var i = 0; i < passwordTrigger.length; i++){
        passwordTrigger[i].addEventListener('click', triggerPassword);
    }
}
//for FILE UPLOAD
var Form = {
    fileInput: '',
    fileHolder: '',
    image_holder: '',
    file_count: '',
    del_holder: '',
    del_count: '',
    historyFiles: [],
    bufferFiles: [],
    countAdd: 0,
    countDel: 0,
    maxFileSizeImg: 2097152,
    maxFileSizeVideo: 10485760,
    maxFileSum: 1,
    typeAccept: [],
    typeImg: ['image/jpeg','image/jpg','image/png','image/gif'],
    typeVideo: ['video/mov','video/mp4','video/wmv','video/mpeg','video/mpg','video/avi','video/flv','video/webm'],
    error: false,
    multiple: false,
    file: function (file){
        this.fileInput = file;
        this.fileHolder = file.parents('.form__group-file');
        this.image_holder = this.fileHolder.find('.file_box');
        this.file_count = this.fileHolder.find('.file-not span');
        this.del_holder = this.fileHolder.find('.file_del');
        this.del_count = this.fileHolder.find('.file_del_count');
        file.attr('accept').split(',').map(function (item){
            return Form.typeAccept.push(item);
        });
        this.maxFileSizeImg =  file.attr('data-maxSizeImg') ? file.attr('data-maxSizeImg') : this.maxFileSizeImg;
        this.maxFileSizeVideo =  file.attr('data-maxSizeVideo') ? file.attr('data-maxSizeVideo') : this.maxFileSizeVideo;
        this.maxFileSum = file.attr('data-maxSum') ? file.attr('data-maxSum') : this.maxFileSum;
        this.multiple = file.attr('multiple') ? true : this.multiple;
        this.fileFromFileList(file,'');
    },
    errorMsg: function (val) {
        this.error = true;
        this.fileInput.attr({'data-error': true, 'text-error': val });
    },
    formFilePreview: function (fileList) {
        Form.image_holder.html('');
        Form.fileHolder.removeClass('form__group-invalid');
        Form.fileHolder.find('.form__tooltip').remove();
        Array.from(fileList).forEach(function (item,index) {
            var fileName = item.name.replace("C:\\fakepath\\", '');
            var fileType = item.type;
            var dataType = fileType.split('/').length > 1 ? fileType.split('/').splice(1, 2).join() : fileType;
            if (selected(Form.typeImg,fileType)){
                if (typeof (FileReader) !== "undefined") {
                    var reader = new FileReader();
                    reader.onload = function (e) {
                        $("<div class='file_preview' data-file-index='"+ index +"' data-del='delete'><div class='file_preview_box'><img class='file_image' src='" + e.target.result + "'></div><span>"+ fileName + "</span></div>").appendTo(Form.image_holder);
                    }
                    reader.readAsDataURL(item);
                } else {
                    $("<div class='file_preview' data-file-index='"+ index +"' data-del='delete'><div class='center file_preview_box' data-file-type='" + dataType + "'></div><span>"+ fileName + "</span></div>").appendTo(Form.image_holder);
                }
            } else  if (selected(Form.typeVideo,fileType)) {
                var video = document.createElement('video');
                video.src = window.URL.createObjectURL(item);
                video.addEventListener('loadeddata', function(e) {
                    var canvas = document.createElement('canvas');
                    canvas.width = this.videoWidth;
                    canvas.height = this.videoHeight;
                    var context = canvas.getContext('2d');
                    context.drawImage(video, 0, 0, this.videoWidth, this.videoHeight);
                    var dataURL = canvas.toDataURL();
                    $("<div class='file_preview' data-file-index='"+ index +"' data-del='delete'><div class='file_preview_box'><img class='file_image' src='" + dataURL + "'></div><span>"+ fileName + "</span></div>").appendTo(Form.image_holder);
                });
            } else{
                $("<div class='file_preview' data-file-index='"+ index +"' data-del='delete'><div class='center file_preview_box' data-file-type='" + dataType + "'></div><span>"+ fileName + "</span></div>").appendTo(Form.image_holder);
            }
        });
        Form.image_holder.show();
        Form.file_count.html('Added ' + Form.countAdd + (Form.countAdd > 1 ? ' files' : ' file'));
        Form.del_holder.removeClass('hidden');
    },
    fileFromFileList: function(file, indexArr) {
        var dtAdd = function (arr,indexArr){
            var dt = new DataTransfer();
            Form.countAdd = 0;
            for (var i = 0; i < arr.length; i++) {
                if(indexArr){
                    if (!selected(indexArr, i)){
                        dt.items.add(arr[i]);
                        ++Form.countAdd;
                    }
                }else{
                    dt.items.add(arr[i]);
                    ++Form.countAdd;
                }
            }
            file.files = dt.files;
            file[0].files = dt.files;
            Form.historyFiles = Array.from(file[0].files);
            Form.bufferFiles = Array.from(file[0].files);
        }
        var cancel = function (val){
            Form.errorMsg(val);
            Form.multiple ? dtAdd(Form.historyFiles) : Form.countAdd = 0, file[0].files.length = 0;
            setTimeout(function () {
                Form.error = false;
                file.removeAttr('data-error').removeAttr('text-error');
                Form.fileHolder.removeClass('form__group-invalid');
                if(Form.countAdd > 0) Form.fileHolder.addClass('form__group-valid');
                Form.fileHolder.find('.form__tooltip').remove();
            }, 5000);
        }
        if(indexArr){
            Form.multiple ? dtAdd(file[0].files, indexArr) : Form.countAdd = 0, file[0].files.length = 0;
            if(file[0].files.length == 0){
                Form.fileHolder.removeClass('form__group-valid');
                Form.fileHolder.find('.form__tooltip').remove();
            }
        }else{
            if ((Form.historyFiles.length + file[0].files.length) <= Form.maxFileSum) {
                Array.prototype.push.apply(Form.bufferFiles, file[0].files);
                for (var i = 0; i < Form.bufferFiles.length; i++) {
                    var f = Form.bufferFiles[i],
                        maxFileSize = selected(Form.typeVideo, f.type) ? Form.maxFileSizeVideo : Form.maxFileSizeImg;
                    if(selected(Form.typeAccept, f.type) || (selected(Form.typeAccept, 'image/*') && selected(Form.typeImg, f.type)) || (selected(Form.typeAccept, 'video/*') && selected(Form.typeVideo, f.type))){
                        if(maxFileSize > parseInt(f.size)){
                            Form.error = false;
                        }else{
                            cancel('last selected file not added, its size is larger ' +  Math.floor(maxFileSize / 1024000) + 'Mb');
                        }
                    }else{
                        cancel('last selected file not added, its type is incorrect');
                    }
                }
                if(Form.error === false){
                    Form.multiple ? dtAdd(Form.bufferFiles) : Form.countAdd = 1;
                    file.removeAttr('data-error text-error');
                    Form.fileHolder.find('.form__tooltip').remove();
                    this.formFilePreview(file[0].files);
                }
            }else{
                cancel('last selected '+ (Form.countAdd > 1 ? ' files' : ' file') +' not added, exceeding limit of ' + Form.maxFileSum +' files');
            }
        }
    },
    formFileDelCount: function (buttonEl){
        if(buttonEl){
            buttonEl.toggleClass("file_preview-del");
            buttonEl.hasClass("file_preview-del") ? (--Form.countAdd, ++Form.countDel) : (++Form.countAdd, --Form.countDel);
        }else{
            Form.countDel = 0;
        }
        Form.countDel > 0 ? (Form.del_count.text('Delete ' + Form.countDel + (Form.countDel > 1 ? ' files?' : ' file?'))) : Form.del_count.text('Choose file');
    },
    formFileDel: function () {
        var filePreviewDel = document.querySelectorAll('.file_preview-del');
        var indexArr = [];
        for(var i = 0; i < filePreviewDel.length; i++) indexArr.push(filePreviewDel[i].getAttribute('data-file-index'));
        this.fileFromFileList(Form.fileInput, indexArr);
        Form.image_holder.find(".file_preview-del").remove();
        Form.countAdd > 0 ? (Form.file_count.html('Added ' + Form.countAdd + (Form.countAdd > 1 ? ' files' : ' file'))) : (Form.del_holder.addClass('hidden'), Form.file_count.html('No file selected'), Form.image_holder.hide());
        this.formFileDelCount();
    }
}
//to ADAPT FILE INPUT IN SAFARI AND IE
function crossBrowserInputFile(){
    if(!document.querySelectorAll('.file-input').length) return;
    var inputFile = document.querySelectorAll('.file-input');
    for(var i = 0; i < inputFile.length; i++){
        if(inputFile[i].hasAttribute('multiple')) inputFile[i].removeAttribute('multiple');
        if(inputFile[i].hasAttribute('data-maxsum')) inputFile[i].removeAttribute('data-maxsum');
        inputFile[i].parentElement.setAttribute('data-btn','Choose file');
    }
}

/* ------------- FORMS END ------------- */

$(window).on('load resize', function () {
    $wW = window.innerWidth;
    $hW = window.innerHeight;
    wScroll = scrollbarWidth();

    var timer = setInterval(function() {

        initTheme();

        resizeSlick();

        clearInterval(timer);
    }, 50);

}).bind('resize', function () {

    //var HEIGHT_PERCENTAGE = .60; // '1' would set the height to 100%
    //var h = "innerHeight" in window 
    //   ? window.innerHeight
    //   : document.documentElement.offsetHeight; 
    //h *= HEIGHT_PERCENTAGE;

    var w1 = "innerHeight" in window
            ? window.innerWidth
            : document.documentElement.offsetWidth;
    w1 *= WIDTH_PERCENTAGE;

    if (w1 > 600) {
        w1 = 600;
    }

/*    $.colorbox.resize({
        maxWidth: 600,
        width: w1
    });*/

}).trigger('resize');    

$(window).on('resize orientationchange', function() {
    var timer = setInterval(function() {
        //for resize
        resizeTopNavMenu(), resizeSlick();
        //for FOOTER
        marginFooter();
        clearInterval(timer);
    }, 50);
});

$(document).ready(function () {
    /* ---------- FORM BEGIN ---------- */
    //for form popup
    showPopUpForm();
    //for form input password
    initPassword();
    //for FORM-FILE: add and delete preview for files type images/video
    $('.file-input').on('change', function () {
        Form.file($(this));
    });
    $('.file_box').on('click', '.file_preview', function () {
        Form.formFileDelCount($(this));
    });
    $(".btnDelete").on("click", function () {
        Form.formFileDel();
    });
    /* ---------- FORM END ---------- */

    $('.js-replace-img').each(function () {
        $(this).attr('src', $(this).data('src'));
    });

    $('.js-notification-close').click(function () {
       $(this).parent().hide();
    });
     //for THEME
    $('.theme-switcher').click(function () {
        choiceTheme();
    });  
      
    var currentLinkPath = window.location.pathname + window.location.search,
            headerMenuItem =   $('.user-nav__item > a').filter('[href="'+currentLinkPath+'"]'),
            headerSubMenuItem =   $('.user-nav-sub__item > a').filter('[href="'+currentLinkPath+'"]');
            
    if (headerSubMenuItem.length) {        
        headerSubMenuItem.addClass('active__page');
        headerSubMenuItem.closest('li.user-nav__item').addClass('nav-item__active');
    } else if (headerMenuItem.length) {
        headerMenuItem.addClass('active__page');
    }
    //for FOOTER
    marginFooter();

    var $linkRegister = document.getElementById('register-link');
    if($linkRegister){
        $linkRegister.addEventListener('click', function (e){
            e.preventDefault();
            var $aside = document.getElementById('aside'),
                $btn = document.getElementById('mob-menu-open'),
                hNav = $aside.clientHeight + 100;
            if($wW < 1200){
                if(hNav >= $hW){
                    $wW < 768 ? ($('#aside').addClass('popup').removeClass('open'), showTopNavMenu()) : ($('#aside').addClass('open').removeClass('popup'), $btn.classList.add("d-none"));
                }else{
                    showTopNavMenu();
                }
            }else{
                closeTopNavMenu();
            }
            return false;
        });
    }

    var $linkFavorite = document.querySelectorAll('a[data-trigger="favorite"]');
    if($linkFavorite.length){
        for(var i = 0; i < $linkFavorite.length; i++){
            $linkFavorite[i].addEventListener('click', function (e){
                e.preventDefault();
                var link = this.parentElement,
                    linkId = this.getAttribute('data-user-id'),
                    linkName = this.getAttribute('data-user-name'),
                    flag = link.classList.contains('active');
                link.classList.toggle('active');
                flag ? (this.setAttribute('title', 'Add ' + linkName + ' to Favorites'), DelFavorites(linkId)) :  (this.setAttribute('title', 'Remove ' + linkName + ' from Favorites'), addFavorites(linkId));
                return false;
            });
        }
    }

    $(document).on('click', '[data-dynamic="user"][data-id] [data-trigger="favoriteToggle"]', function(e){
        e.stopPropagation();
        e.preventDefault();
        var parentsEl = $(this).parents('[data-dynamic="user"]');
        var ID = parentsEl.data('id');
        var isFavorite = parentsEl.attr('data-favorite') === 'true';
        isFavorite ? DelFavorites(ID) : addFavorites(ID);
    });

    $('#mob-menu-open').on('click', function () {
        window.scroll(0, 0);
        if($wW < 768){
            showTopNavMenu();
        }else if($wW < 1200){
            if($('#aside').hasClass('aside-nav')){
                $('#aside').addClass('open').removeClass('popup');
            }else{
                showTopNavMenu();
            }
        }else{
            $('#aside').addClass('open').removeClass('popup');
        }
        $(this).addClass("d-none");
    });

    $('#mob-menu-close').click(function () {
        closeTopNavMenu();
    });

    $('.user-nav__item > a').click(function () {
        if ($(this).siblings('.user-nav-sub__list').length > 0) {
            $(this).parent().toggleClass('nav-item__active');
            marginFooter();
            if($wW < 768) minHW();
            return false;
        }
    });
    
    if ($('.b-slider__comments').length > 0) {               
        
        $('.b-slider__comments').slick({
            infinite: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            //vertical: true,
            adaptiveHeight: true,            
            /*responsive: [{
                breakpoint: 1200,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,                            
                }
            }]*/
        });
    }

});

function resizeSlick() {
    if (!$('.slider-sm').length) return;
    if ($(window).width() < 768) {
        if ($('.slider-sm').not('.slick-initialized').length) {
            $('.slider-sm').slick({
                infinite: true,
                arrows : true,
                nextArrow: '<button class="slick-next slick-arrow" aria-label="Next" type="button">Next</button>',
                prevArrow: '<button class="slick-prev slick-arrow" aria-label="Previous" type="button">Previous</button>',
                slidesToShow: 1,
                slidesToScroll: 1
            });
        }
    } else {
        $('.slider-sm').filter('.slick-initialized').slick('unslick');
    }        
}

// login, register
    function VoteVideo(id_video){
        if(id_video){
            $('.sendd a').attr('href', '/vote_video.php?com=vote&id_video='+id_video);
            $('#basic-modal-content_vote').modal(); 
        }
              
    }
    function check_id(){

	    if($("#input_confirm_popup").val() == 0){
		alert("ID number that you have entered is incorrect. Lady's image will appear if information is correct.")
		return false;
	    }
	    return true;
	}
    function SearchLady(){
	var search = $("#id_lady").val();
			if(search.length >= 6 && search.length <= 7){
			    $.ajax({
				    type: "POST",
				    url: "/ajax_search.php?com=search",
				    data: {"search": search},
				    cache: false,
				    success: function(response){
					if(response){
					    $("#input_confirm_popup").val(1);
					    $("#search_result_popup").html(response);
                                            $("#simplemodal-container").css("height", "350px");
					}
					else {
					    $("#input_confirm_popup").val(0);
					    $("#search_result_popup").html("<div class=\"texet\">Not found</div>");
					}
				    }
			    });
			}else {
			    $("#input_confirm_popup").val(0);
			    $("#search_result_popup").html("<div class=\"texet\">Not found</div>");
			}
			return false;
    }
    function add_credits() {
        swal({
            title: 'Payments Service',
            html: '<div>Payment for additional services will be charged from your account.</div><div>Sorry, but you do not have enough credits on your account to complete your request. You can purchase more credits <a href="/payment-page/">here</a>.</div>'
        });
    }
    function search(cat,id_present){
	$('.hidden').html("<input type='hidden' value='"+id_present+"' name='present_id'>");
	$('#basic-modal-content2').modal();
	$('#simplemodal-container').animate({height:321},"slow");
    }
    function login_here(namediv){
	$('.basic-modal-main').fadeOut("slow",function(){
	    $('.basic-modal-'+namediv).fadeIn("slow");
	    //if(namediv == 'log') $("#simplemodal-container").animate({height:238},"slow");
	    if(namediv == 'register'){
                var id = $('.basic-modal-lady').attr('id');                                                    
                if(id){
                        $("#simplemodal-container").animate({height:620,width:780,marginTop:-200,marginLeft:-200},"slow");
                        $.ajax({
				    type: "POST",
				    url: "/ajax.php?com=load_photo",                                       
				    data: {"id":id},
                                    async:false,
				    success: function(data){
					 if(data){
                                            data = jQuery.parseJSON(data);                                               
                                            $(".basic-modal-lady").append('<img src="/uploades/photos/'+data.upload_path+'" width="400">');
                                            $("#name").html(data.fname);
                                        }
				    }
			    });                         
                    }else{
                        //$("#simplemodal-container").animate({height:380,width:360,marginTop:-200},"slow");
                        $("#simplemodal-container").css({"height":530}).css({"width":360});
                        var mrgLeft = ($(window).width() - $("#simplemodal-container").width()) / 2;
                        var mrgTop = ($(window).height() - $("#simplemodal-container").height()) / 2;
                        $("#simplemodal-container").css({"top":mrgTop+'px'}).css({"left":mrgLeft+'px'});
                    }
                    var varr = 2;
                        //alert(varr);
                    if(varr) $("#id_link"+varr).click();
            }
	});

    }
    function lg_reg(link,name,cat,id){
        sign_up();
//	if(cat == 'message') var text = "To send a message to <a href='"+link+"'>"+name+"</a>, please";
//	else if(cat == 'video') var text = "To view <a href='"+link+"'>"+name+"'s</a> video, please";
//	else if(cat == 'real_present') {
//	    if(!name && !link)
//		var text = "To send a gift please";
//	    else
//		var text = "To send a gift to <a href='"+link+"'>"+name+"</a>, please";
//	}
//	else if(cat == 'chat') {
//	    if(name)
//		var text = "To start chat with <a href='"+link+"'>"+name+"</a>, please";
//	    else
//		var text = "To start chat, please";
//
//	    $("#modal_form").attr('action', '/chat/');
//	}
//	else if(cat == 'pay_sys'){
//	    var text = "To add credits, please";
//	    $("#modal_form").attr('action', '/payment-page/');
//	}
//	else if(cat == 'e-card'){
//	    if(!name && !link)
//		var text = "To send a card please";
//	    else
//		var text = "To send a card to <a href='"+link+"'>"+name+"</a>, please";
//	}
//
//	else if(cat == 'kiss') var text = "To send a kiss to <a href='"+link+"'>"+name+"</a>, please";
//	else if(cat == 'call') var text = "To call to <a href='"+link+"'>"+name+"</a>, please";
//	else if(cat == 'virtual_gift'){
//	    if(!name && !link)
//		var text = "To send a virtual gift please";
//	    else
//		var text = "To send a virtual gift to <a href='"+link+"'>"+name+"</a>, please";
//	}
//	else if(cat == 'photo') var text = "To see <a href='"+link+"'>"+name+"'s</a> photos, please";
//	else if(cat == 'gold') var text = "Current service is available only for Gold members.";
//	else if(cat == 'vip') {
//		var text = "Current service is available only for VIP members.";
//		$('#basic-modal-content a').attr('href', '/membership.php?id=2');
//	}
//	else if(cat == 'add_fav') var text = "To add <a href='"+link+"'>"+name+"</a> to your Favourites, please";
//        else if(cat == 'vote_video') {var text = "To vote this video, please";$("#modal_form").attr('action', '/vote_video.php');}
//        
//	$('.basic-modal-head').html(text);
//        if(cat != 'gold' && cat != 'vip' && id != 0) $('.basic-modal-lady').attr('id',id);
//	$('#basic-modal-content').modal();
//        $("#simplemodal-container").css({"height":155}).css({"width":330});
//        var mrgLeft = ($(window).width() - $("#simplemodal-container").width()) / 2;
//        var mrgTop = ($(window).height() - $("#simplemodal-container").height()) / 2;
//        $("#simplemodal-container").css({"top":mrgTop+'px'}).css({"left":mrgLeft+'px'});
    }
function showPopUpForm(){
    if(!localStorage.getItem('form')) return;
    localStorage.getItem('form') == 'init' ? showTopNavMenu() : resizeForm();
}
function resizeForm() {
    if($wW < 1200){
        showTopNavMenu();
    }else{
        if(!localStorage.getItem('form')){
            closeTopNavMenu();
        }
    }
}
function goForm(url,val){
    if(url) window.location.href = url;
    if(val){
        localStorage.setItem('form', val);
    }else{
        if(localStorage.getItem('form')) localStorage.removeItem('form');
    }
}
function sign_up(id) {

    showTopNavMenu();

    if (id != 'undefined') {
        $.ajax({
            type: "POST",
            url: "/ajax.php?com=load_photo",
            data: {
                "id": id
            },
            async: false,
            success: function (data) {
                if (data) {
                    data = jQuery.parseJSON(data);
                    $(".popup_register_content").prepend(
                        '<div id="popup_lady_image"><img src="/uploades/photos/' + data.upload_path + '" alt="" /></div>'
                    );
                }
            }
        });
    }

    return false;

//~        if(id){

    //$("#simplemodal-container").animate({height:620,width:780,marginTop:-200,marginLeft:-200},"slow");
//~                        $.ajax({
//~				    type: "POST",
//~				    url: "/ajax.php?com=load_photo",                                       
//~				    data: {"id":id},
//~                                    async:false,
//~				    success: function(data){                                    
//~					 if(data){
//~                                            data = jQuery.parseJSON(data);
//~                                            $(".basic-modal-lady").html('<img src="/uploades/photos/'+data.upload_path+'" alt="">');
//~                                            $("#name").html(data.fname);
//~                                        }
//~				    }
//~			    });                         
//~                    }                  

//~                    $('#basic-modal-content-register').modal();
//~                    closePreview();
    //$("#simplemodal-container").animate({height:620,width:780,marginTop:-200,marginLeft:-200},"slow");
//                    $("#simplemodal-container").css({"height":620}).css({"width":780});
//                    var mrgLeft = ($(window).width() - $("#simplemodal-container").width()) / 2;
//                    var mrgTop = ($(window).height() - $("#simplemodal-container").height()) / 2;
//                    $("#simplemodal-container").css({"top":mrgTop+'px'}).css({"left":mrgLeft+'px'});
//                    //var varr = $("#varr").val();
//                    var varr = 1;
//                        //alert(varr);
//                    if(varr) $("#id_link"+varr).click();

}
    
    
function previewAnketa(id) {
    //if ($(window).width() > 500) { 
    if (id && !$(".preview_anketa_block#" + id).length) {
        $.ajax({
            url: '/ajax.php?com=preview_anketa',
            method: 'GET',
            data: {'id': id},
            success: function (data) {
                if (data) {
                    $("body").append('<div class="previewOverlay" onclick="closePreview()"></div>');
                    $("body").append(data);
                    //var left = ($(window).width() - $(".preview_anketa_block").outerWidth()) / 2;
                    //var top = ($(window).height() - $(".preview_anketa_block").outerHeight()) / 2;    
                    //if(top <= 0) top = 30;
                    //$(".preview_anketa_block").css('left', left+'px').css('top', top+'px');

                    $(".preview_anketa_block a[rel='gallery_" + id + "']").colorbox({
                        transition: "fade",
                        maxWidth: 400,
                        width: w1,
                        title: false,
                        onComplete: function () {}
                    });
                }
            }
        });
    } else if ($(".preview_anketa_block#" + id).length) {
        $("body").append('<div class="previewOverlay" onclick="closePreview()"></div>');
        $(".preview_anketa_block#" + id).show();
    }
    return false;

    //} else {
    //    window.location.href = $('.anketa-' + id).find('a').attr('href');        
    //}       
}

    
function closePreview(){
    if($(".previewOverlay").length > 0)  $(".previewOverlay").remove();
    if($(".preview_anketa_block").length > 0) $(".preview_anketa_block").remove();
    $('.main-wrapper').removeAttr('style');
}    

$(document).keyup(function(e) {
  if (e.keyCode == 27) {
      closePreview();

      if ($('#mob-menu-close').length > 0) {
          $('#mob-menu-close').click();
      }
  } 
});    
